import RoundImage from 'components/atoms/RoundImage';
import Button from 'components/atoms/teachers/Button';
import ModalTextContainer from 'components/molecules/teachers/ModalTextContainer';
import { colors } from 'constants/colors';
import React from 'react';
import styled from '@emotion/styled';
import getPartner from 'utils/getPartner';
import resolvePath from 'utils/resolvePath';
export default (props) => {
    const { conversation, myId, path, close } = props;
    const partner = getPartner(conversation, myId);
    return (React.createElement(Container, null,
        React.createElement(ModalTextContainer, { heading: 'しゃべる相手が見つかりました', text: '詳細を確認してみましょう' }),
        React.createElement(RoundImage, { src: partner ? partner.picture_url : '', size: 200, marginBottom: 24, code: partner ? partner.country_code : '' }),
        React.createElement(Name, null, partner ? partner.name : ''),
        React.createElement(ButtonContainer, null,
            React.createElement(Button, { type: "white", text: "\u3068\u3058\u308B", width: 272, height: 112, fontSize: 40, onClick: () => close() }),
            React.createElement(Button, { type: "blue", text: "\u8A73\u7D30\u3092\u898B\u308B", width: 272, height: 112, fontSize: 40, link: resolvePath.page('teachers', path), onClick: () => close() }))));
};
const Container = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 40px;
  width: 100%;
`;
const ButtonContainer = styled.div `
  display: flex;
  gap: 40px;
  justify-content: space-between;
  margin-top: auto;

  & > Button {
    flex: 1;
  }
`;
const Name = styled.div `
  margin-bottom: 40px;
  font-size: 40px;
  font-weight: 500;
  letter-spacing: 0px;
  text-align: center;
  color: ${colors[405766]};

  &::after {
    margin-left: 8px;
    font-size: 32px;
    content: 'さん';
  }
`;
